<template>
  <div>
    <table>
      <thead>
        <tr ref="filter-row">
          <th v-for="(head, key) in filterHeaders" :key="key" :id="`${key}`">
            <div class="filter-result">
              <div>
                <div
                  :class="[{ 'filter-result__item': filter(head).length != 0 }]"
                  v-for="(el, key) in filter(head)"
                  :key="key"
                >
                  {{ el }}
                </div>
              </div>
            </div>
          </th>
        </tr>
      </thead>
    </table>
  </div>
</template>

<script>
import('@/styles/components/filter-result.less')

export default {
  name: 'FilterResult',
  props: {
    data: {
      type: Object,
      required: true
    },
    headers: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    filterHeaders: {}
  }),
  computed: {},
  created() {
    this.comparisonObject()
  },
  mounted() {
    this.$nextTick(() => {
      this.setWidth()
    })
  },
  updated() {
    this.setWidth()
  },
  methods: {
    setWidth() {
      this.$refs['filter-row'].childNodes.forEach(item => {
        let id = `${item.id}-head`
        if (document.getElementById(id)) item.style.width = `${document.getElementById(id).clientWidth}px`
      })
    },
    filter(head) {
      if (!Array.isArray(head)) {
        if (this.data[head.title]) {
          if (Array.isArray(this.data[head.title])) {
            let str = null
            this.data[head.title].forEach(element => {
              str = str ? `${str}, ` + element : element
            })
            return [str]
          } else {
            return [this.data[head.title]]
          }
        } else return []
      } else {
        let arr = []

        head.forEach(element => {
          if (element.title === 'ID') arr.push(`Id: ${this.data[element.title]}`)
          else if (element.title === this.$t('general.type')) {
            let str = null
            this.data[element.title].forEach(element => {
              str = str ? `${str}, ` + element : element
            })
            arr.push(`${this.$t('general.type')}: ${this.data[element.title]}`)
          } else arr.push(this.data[element.title])
        })
        return arr
      }
    },
    comparisonObject() {
      this.filterHeaders = Object.assign({}, this.headers)
      this.filterHeaders['edit'] = []
      let arr = []
      // eslint-disable-next-line no-unused-vars
      for (let key in this.filterHeaders) {
        arr.push(this.filterHeaders[key].title)
      }
      Object.keys(this.data).forEach(item => {
        if (!arr.includes(item)) {
          this.filterHeaders['edit'].push({
            title: item
          })
        }
      })
    }
  }
}
</script>
